import request from './request';
// 查询是否可以参加活动
export const isCanJoin = () =>
  request({
    url: '/remain/activation/canJoin',
    method: 'GET'
  });

// 查询是否存在留存奖励
export const remainInfo = () =>
  request({
    url: '/remain/activation/info',
    method: 'GET'
  });
// 领取奖励
export const submitRemainAward = () =>
  request({
    url: '/remain/activation/getAward',
    method: 'GET',
  });
